import { Injectable, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { PATHS } from '@constants';

type ErrorAction = 'close' | 'redirect-welcome' | 'redirect-welcome-silent';

interface ErrorConfig {
  title: string;
  message: string;
  action: ErrorAction;
}

/** Mapa de codigos de error del backend a claves i18n */
const ERROR_MESSAGES: Record<string, ErrorConfig> = {

  // ── Fallback generico ──
  default: {
    title: 'error_modal_title',
    message: 'error_modal_message',
    action: 'close'
  },

  // ── Errores de servidor ──
  ERRNO_001: {
    title: 'error_modal_title',
    message: 'error_ERRNO_001',
    action: 'close'
  },
  ERROR_ONB_MD_0: {
    title: 'error_modal_title',
    message: 'error_ERROR_ONB_MD_0',
    action: 'close'
  },
  ERRNO_500: {
    title: 'error_modal_title',
    message: 'error_ERRNO_500',
    action: 'close'
  },

  // ── Errores de proceso de onboarding ──
  ERRNO_002: {
    title: 'error_modal_title',
    message: 'error_ERRNO_002',
    action: 'close'
  },
  ERRNO_003: {
    title: 'error_modal_title',
    message: 'error_ERRNO_003',
    action: 'close'
  },
  ERRNO_004: {
    title: 'error_modal_title',
    message: 'error_ERRNO_004',
    action: 'close'
  },
  ERRNO_005: {
    title: 'error_modal_title',
    message: 'error_ERRNO_005',
    action: 'close'
  },
  ERRNO_006: {
    title: 'error_modal_title',
    message: 'error_ERRNO_006',
    action: 'close'
  },
  ERRNO_007: {
    title: 'error_modal_title',
    message: 'error_ERRNO_007',
    action: 'close'
  },
  ERRNO_008: {
    title: 'error_modal_title',
    message: 'error_ERRNO_008',
    action: 'close'
  },

  // ── Errores SSN ──
  ERRSSN_003: {
    title: 'error_modal_title',
    message: 'error_ERRSSN_003',
    action: 'close'
  },
  ERRSSN_007: {
    title: 'error_modal_title',
    message: 'error_ERRSSN_007',
    action: 'close'
  },
  ERRSSN_008: {
    title: 'error_modal_title',
    message: 'error_ERRSSN_008',
    action: 'close'
  },
  'ERRSSN_008_': {
    title: 'error_modal_title',
    message: 'error_ERRSSN_008_',
    action: 'close'
  },
  ERRSSN_013: {
    title: 'error_modal_title',
    message: 'error_ERRSSN_013',
    action: 'close'
  },

  // ── Sesion expirada / no autorizado ──
  '401': {
    title: 'error_modal_title',
    message: 'error_modal_message',
    action: 'redirect-welcome-silent'
  },

  // ── Reinicio de onboarding (redirect sin modal) ──
  ERROCHEX_005: {
    title: 'error_modal_title',
    message: 'error_modal_message',
    action: 'redirect-welcome-silent'
  },
  ERRSSN_005: {
    title: 'error_modal_title',
    message: 'error_modal_message',
    action: 'redirect-welcome-silent'
  },
  ERRPPWD_005: {
    title: 'error_modal_title',
    message: 'error_modal_message',
    action: 'redirect-welcome-silent'
  },
  ERROOW_005: {
    title: 'error_modal_title',
    message: 'error_modal_message',
    action: 'redirect-welcome-silent'
  },
  ERROFAC_005: {
    title: 'error_modal_title',
    message: 'error_modal_message',
    action: 'redirect-welcome-silent'
  },
  ERROKYC_005: {
    title: 'error_modal_title',
    message: 'error_modal_message',
    action: 'redirect-welcome-silent'
  },
  ERROCONF_005: {
    title: 'error_modal_title',
    message: 'error_modal_message',
    action: 'redirect-welcome-silent'
  },
  ERROAUTH_006: {
    title: 'error_modal_title',
    message: 'error_modal_message',
    action: 'redirect-welcome-silent'
  },
  ERROADDR_005: {
    title: 'error_modal_title',
    message: 'error_modal_message',
    action: 'redirect-welcome-silent'
  },

  // ── Error de recuperacion de datos (modal + redirect) ──
  ONB2_028: {
    title: 'error_modal_title',
    message: 'error_ONB2_028',
    action: 'redirect-welcome'
  },
  ONB2_029: {
    title: 'error_modal_title',
    message: 'error_ONB2_028',
    action: 'redirect-welcome'
  },

  // ── Errores de proceso especificos ──
  ERRRO_003: {
    title: 'error_modal_title',
    message: 'error_ERRRO_003',
    action: 'redirect-welcome'
  },
  ERRPI_002: {
    title: 'error_modal_title',
    message: 'error_ERRPI_002',
    action: 'close'
  },
  ERROADDR_002: {
    title: 'error_modal_title',
    message: 'error_ERROADDR_002',
    action: 'close'
  },
  ERROADDR_003: {
    title: 'error_modal_title',
    message: 'error_ERROADDR_003',
    action: 'close'
  },

  // ── Errores OTP (con y sin prefijo ERRNO_) ──
  ERRNO_902: {
    title: 'error_otp_title',
    message: 'error_ERRNO_902',
    action: 'close'
  },
  '902': {
    title: 'error_otp_title',
    message: 'error_ERRNO_902',
    action: 'close'
  },
  ERRNO_903: {
    title: 'error_otp_title',
    message: 'error_ERRNO_903',
    action: 'close'
  },
  '903': {
    title: 'error_otp_title',
    message: 'error_ERRNO_903',
    action: 'close'
  },
  ERRNO_904: {
    title: 'error_otp_title',
    message: 'error_ERRNO_904',
    action: 'close'
  },
  '904': {
    title: 'error_otp_title',
    message: 'error_ERRNO_904',
    action: 'close'
  },
  ERRNO_905: {
    title: 'error_modal_title',
    message: 'error_ERRNO_905',
    action: 'close'
  },
  '905': {
    title: 'error_modal_title',
    message: 'error_ERRNO_905',
    action: 'close'
  },
  ERRNO_906: {
    title: 'error_modal_title',
    message: 'error_ERRNO_906',
    action: 'close'
  },
  '906': {
    title: 'error_modal_title',
    message: 'error_ERRNO_906',
    action: 'close'
  },
  ERRNO_907: {
    title: 'error_otp_title',
    message: 'error_ERRNO_907',
    action: 'close'
  },
  '907': {
    title: 'error_otp_title',
    message: 'error_ERRNO_907',
    action: 'close'
  },
  ERRNO_950: {
    title: 'error_modal_title',
    message: 'error_ERRNO_950',
    action: 'close'
  },
  '950': {
    title: 'error_modal_title',
    message: 'error_ERRNO_950',
    action: 'close'
  },

  // ── Username ──
  ERRNO_752: {
    title: 'error_modal_title',
    message: 'error_ERRNO_752',
    action: 'close'
  },
  '752': {
    title: 'error_modal_title',
    message: 'error_ERRNO_752',
    action: 'close'
  },
};

@Injectable({ providedIn: 'root' })
export class ErrorModalService {
  private readonly router = inject(Router);

  readonly visible = signal(false);
  readonly title = signal('error_modal_title');
  readonly message = signal('error_modal_message');
  readonly errorCode = signal('');

  private pendingAction: ErrorAction = 'close';

  show(errorCode?: string): void {
    const code = errorCode ?? 'default';
    const config = ERROR_MESSAGES[code] ?? ERROR_MESSAGES['default'];

    if (config.action === 'redirect-welcome-silent') {
      this.router.navigate([PATHS.welcome]);
      return;
    }

    this.errorCode.set(code);
    this.title.set(config.title);
    this.message.set(config.message);
    this.pendingAction = config.action;
    this.visible.set(true);
  }

  hide(): void {
    const action = this.pendingAction;
    this.visible.set(false);
    this.pendingAction = 'close';

    if (action === 'redirect-welcome') {
      this.router.navigate([PATHS.welcome]);
    }
  }
}
